

























































import { Component, Vue } from "vue-property-decorator";

@Component
export default class LatestNews extends Vue {
  data() {
    return {
      blogs: [
        {
          name: "Adama kind deep gatherin first over fter his great",
          img: require("../assets/blog/blog_1.png"),
          date: "Apr 06, 2019",
          tag: "Food News"
        },
        {
          name: "Adama kind deep gatherin first over fter his great",
          img: require("../assets/blog/blog_2.png"),
          date: "Apr 06, 2019",
          tag: "Food News"
        },
        {
          name: "Adama kind deep gatherin first over fter his great",
          img: require("../assets/blog/blog_3.png"),
          date: "Apr 06, 2019",
          tag: "Food News"
        }
      ]
    };
  }
}
